export default "__VITE_ASSET__Dbjvf5YW__"